import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';

import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import { PopupboxManager } from 'react-popupbox';
import React from 'react';
import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

function CheckboxList(props) {
  const classes = useStyles();

  const [checked, setChecked] = React.useState([]);

  const [checkedProtein, setCheckedProtein] = React.useState([]);
  // const [toppings,setToppings] = React.useState([]);

  const [manyChecked, setManyChecked] = React.useState([]);

  const manyHandleToggle = (value) => () => {
    const currentIndex = manyChecked.indexOf(value);
    const newChecked = [...manyChecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setManyChecked(newChecked);
  };

  const handleClose = () => {
    clearItems();

    // PopupboxContainer.close();
    PopupboxManager.close();
    var body = document.getElementById('main-body');
    body.style.overflow = 'scroll';
  };

  const clearItems = () => {
    checked.map(() => {
      const newChecked = [];
      setChecked(newChecked);
      return;
    });
    manyChecked.map(() => {
      const newChecked = [];
      setManyChecked(newChecked);
      return;
    });
    checkedProtein.map(() => {
      const newChecked = [];
      setCheckedProtein(newChecked);
      return;
    });
  };

  const handleSubmit = (e) => {
    const { addItem } = checked;
    //e.preventDefault();
    const toCart = props.item;

    const list = Array.prototype.concat.apply(
      [],
      [checked, checkedProtein, manyChecked]
    );

    const order = {
      item: toCart.item,
      toppings: list,
      price: toCart.price,
    };

    //dispatch order to redux
    props.setOrder(order);

    clearItems();

    if (checked <= 0) {
      alert('Atleast one item must be checked');
    } else {
      PopupboxManager.close();
    }
  };
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    if (checked.length <= 0) {
      setChecked(newChecked);
    } else if (value === checked[0]) {
      setChecked(newChecked);
    }
    var body = document.getElementById('main-body');
    body.style.overflow = 'scroll';
  };

  const handleToggleProtein = (value) => () => {
    const currentIndex = checkedProtein.indexOf(value);
    const newChecked = [...checkedProtein];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    if (checkedProtein.length <= 0) {
      setCheckedProtein(newChecked);
    } else if (value === checkedProtein[0]) {
      setCheckedProtein(newChecked);
    }
  };

  return (
    <div>
      <List className={classes.root}>
        {props.protein.length > 0 ? 'Select 1 Required' : console.log('')}

        {props.protein.map((value) => {
          const labelId = `checkbox-list-label-${value}`;

          return (
            <ListItem
              key={value}
              role={undefined}
              dense
              button
              onClick={handleToggleProtein(value)}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={checkedProtein.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>

              <ListItemText id={labelId} primary={value} />
            </ListItem>
          );
        })}
        {props.one.length > 0 ? 'Select 1 Required' : console.log('')}
        {props.one.map((value) => {
          const labelId = `checkbox-list-label-${value.itemName}`;

          return (
            <ListItem
              key={value.itemName}
              role={undefined}
              dense
              button
              onClick={handleToggle(value.itemName)}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={checked.indexOf(value.itemName) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>

              <ListItemText id={labelId} primary={value.itemName} />
              <IconButton edge="end" aria-label="comments">
                <FormHelperText>
                  + ${parseFloat(value.price).toFixed(2)}
                </FormHelperText>
              </IconButton>
            </ListItem>
          );
        })}

        {props.many.length > 0 ? 'Select Many' : console.log('')}
        {props.many.map((value) => {
          const labelId = `checkbox-list-label-${value.name}`;

          return (
            <ListItem
              key={value.name}
              role={undefined}
              dense
              button
              onClick={manyHandleToggle(value.name)}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={manyChecked.indexOf(value.name) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value.name} />
              <IconButton edge="end" aria-label="comments">
                <FormHelperText>
                  + ${parseFloat(value.price).toFixed(2)}
                </FormHelperText>
              </IconButton>
            </ListItem>
          );
        })}
      </List>
      <IconButton edge="end" aria-label="comments">
        <div>
          <Button style={{ color: '#00adff' }} onClick={handleSubmit}>
            add
          </Button>
          <Button style={{ color: '#00adff' }} onClick={handleClose}>
            cancel
          </Button>
        </div>
      </IconButton>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    order: state.data.order,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setOrder: (order) => {
      dispatch({ type: 'SET_ORDER', order: order });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CheckboxList);
